import type { DashboardTemplate } from '@/entities/dashboard-template';

type DashboardTemplateCardProps = {
  template: DashboardTemplate;
  onClick: (template: DashboardTemplate) => void;
};

const getCardTitle = (template: DashboardTemplate) =>
  template.name.replace(/ Dashboard$/, '');

const getRowCount = (template: DashboardTemplate) =>
  template.layout.filter((row) => row.type === 'chart').length;

export const DashboardTemplateCard = ({
  template,
  onClick,
}: DashboardTemplateCardProps) => {
  return (
    <button
      type="button"
      onClick={() => onClick(template)}
      className="flex min-h-[130px] w-full cursor-pointer flex-col justify-between gap-3 rounded-md bg-primary/5 p-5 text-left transition-colors hover:bg-primary/10 sm:w-[300px]"
    >
      <div className="space-y-2">
        <h3 className="text-sm font-semibold text-gray-800">
          {getCardTitle(template)}
        </h3>
        <p className="text-xs leading-[1.4] text-gray-700">
          {template.description}
        </p>
      </div>
      <p className="text-xs font-medium text-gray-600">
        {template.charts.length} charts · {getRowCount(template)} rows
      </p>
    </button>
  );
};
